// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32-WF","rootNoMargin":"styles_rootNoMargin__3Huot"};